import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { ToneRoot } from '@/components/generals/tone'
import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children, tone = 'void', footerCta = true }): ReactNode => {
    return (
        <ToneRoot initial={tone}>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[110] focus:bg-mist focus:px-4 focus:py-3 focus:text-void'
            >
                Skip to content
            </a>

            <Header />

            <main id='main' className='relative'>
                {children}
            </main>

            <Footer cta={footerCta} />
        </ToneRoot>
    )
}
